module.exports = __webpack_public_path__ + "img/card6.e8b69d09.jpg";